import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./ContactUs.css";
import AdelaideBanner from "../Assets/ContactUs/Adelaide-banner-img.png";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { motion } from "framer-motion";
import sLocation from "../Assets/ContactUs/s-location.png";
import sCall from "../Assets/ContactUs/s-call.png";
import sMail from "../Assets/ContactUs/s-mail.png";
import sClock from "../Assets/ContactUs/s-clock.png";
import Google from "../Assets/Google.png";
import GoogleG from "../Assets/Google-G.png";
import verified from "../Assets/ti-verified.svg fill.png";
import { LoadScript } from "@react-google-maps/api";
import SuccessPopup from './../thankyoupop/thankyoupop'; // Adjust path as needed

import api, { PUBLIC_BASE_URL, BASE_URL } from "../Api/api";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GoogleAddressInput from "../GoogleAddressInput";
import OpenCageAutocomplete from "../OpenCageAutocomplete";

const ContactUs = () => {
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  useEffect(() => {
    if (!window.google) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["geocode"],
        componentRestrictions: { country: "au" }, // restrict to Australia
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      console.log("Selected place:", place);
      // You can also set the selected value to a state
    });
  }, []);

  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("testimonials").then((res) => {
      setTestimonials(res.data.testimonials);
    });
  }, []);

  const [scrollIndex, setScrollIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3);
  const scrollRef = useRef();
  const CARD_WIDTH = 300 + 16; // width + margin

  useEffect(() => {
    const updateVisibleCards = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setVisibleCards(1);
      } else if (width < 768) {
        setVisibleCards(1);
      } else if (width < 992) {
        setVisibleCards(2);
      } else {
        setVisibleCards(3);
      }
    };

    updateVisibleCards();
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  const scroll = (direction) => {
    const maxIndex = Math.ceil(testimonials.length / visibleCards) - 1;
    let newIndex = scrollIndex;

    if (direction === "left") {
      newIndex = Math.max(0, scrollIndex - 1);
    } else if (direction === "right") {
      newIndex = Math.min(maxIndex, scrollIndex + 1);
    }

    setScrollIndex(newIndex);

    if (scrollRef.current) {
      scrollRef.current.style.transform = `translateX(-${
        newIndex * CARD_WIDTH * visibleCards
      }px)`;
    }
  };

  const renderStars = (count) =>
    Array.from({ length: count }, (_, i) => (
      <b key={i} className="fa-solid fa-star" style={{ color: "gold" }}>
        ★
      </b>
    ));

  const [reviewCount, setReviewCount] = useState(null);

  useEffect(() => {
    api
      .get("google-review-count")
      .then((res) => {
        if (res.data) {
          setReviewCount(res.data.review_count);
        }
      })
      .catch((err) => {
        console.error("Error fetching Google Review Count:", err);
      });
  }, []);

  const [heroData, setHeroData] = useState(null);

  useEffect(() => {
    api
      .get("contact-hero-section")
      .then((response) => {
        setHeroData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching contact hero data:", error);
      });
  }, []);

  const inputRef = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    address: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState(""); // success or error

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    const response = await api.post("/contact-submit", formData, {
      headers: { "Content-Type": "application/json" },
    });

    if (response.data.success) {
      setShowSuccessPopup(true);

      // ✅ Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        city: "",
        address: "",
        message: "",
        captcha: "",
      });
    } else {
      toast.error("❌ Submission failed. Please try again.");
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("❌ An error occurred. Please check the console.");
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <div>
      <Header />
      <section
        className="hero-section position-relative text-white d-flex align-items-center justify-content-center"
        style={{
          background: `url(${PUBLIC_BASE_URL}${heroData?.background_image}) center/cover no-repeat`,
          height: "100vh",
        }}
      >
        {/* Overlay for contrast */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            // background: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          }}
        ></div>

        {/* Animated content */}
        <motion.div
          className="container text-center position-relative"
          style={{ zIndex: 2 }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h1 className="display-4 fw-bold mb-2">{heroData?.title}</h1>
          <p className="lead mb-0">{heroData?.subtitle}</p>
        </motion.div>
      </section>

      <section className="contact-section py-5">
        <div className="container">
          {/* Optional Heading */}
          <div className="text-center mb-5">
            <span className="d-block text-primary fw-semibold">
              <h2> — Get in Touch </h2>
            </span>
            {/* <h2 className="fw-bold mt-2">
        Let's Connect! Inquire About Our Services Today
      </h2> */}
          </div>

          <div className="row gy-4 align-items-stretch">
            {/* <h3 style={{ color: "#001070" }}>Our Contact Details</h3> */}
            {/* Contact Form */}
            <div className="col-lg-6 d-flex">
              <form
                onSubmit={handleSubmit}
                className="p-4 bg-light rounded shadow w-100"
              >
                <div className="mb-3 mt-5">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    required
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3 mt-5">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    required
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3 mt-5">
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Phone"
                    required
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3 mt-5">
                  <select
                    className="form-select"
                    name="city"
                    required
                    value={formData.city}
                    onChange={handleChange}
                  >
                    <option value="">Select City</option>
                    <option value="Adelaide" selected>
                      {" "}
                      Adelaide
                    </option>
                    {/* <option value="Melbourne">Melbourne</option> */}
                  </select>
                </div>
                <div className="mb-3 mt-5">
                  <OpenCageAutocomplete
                    type="text"
                    className="form-control"
                    placeholder="Address"
                    required
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                  {/* <GoogleAddressInput
                    ref={inputRef}
                    type="text"
                    className="form-control"
                    placeholder="Address"
                    required
                    name="address"
                    value={formData.address || ""}
                    onChange={handleChange}
                  /> */}
                </div>

                <div className="mb-3 mt-5">
                  <textarea
                    className="form-control"
                    placeholder="Message (optional)"
                    rows="4"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>
                <div className="mb-3 mt-5">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="What is 6 + 4?"
                    required
                    name="captcha"
                    value={formData.captcha}
                    onChange={handleChange}
                  />
                </div>
                {/* <button type="submit" className="btn btn-primary w-100">
                  Submit
                </button> */}

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
                <SuccessPopup 
  isVisible={showSuccessPopup}
  onClose={() => setShowSuccessPopup(false)}
  message="Thank you! Your form has been submitted successfully. We'll get back to you soon!"
/>

                {/* Toast container for notifications */}
                <ToastContainer position="top-right" autoClose={3000} />
              </form>
            </div>

            {/* Contact Info */}
            <div className="col-lg-6 d-flex">
              <div className="bg-white p-4 rounded shadow w-100 contact-info">
                {/* Adelaide Office */}
                <div className="info-box p-3 bg-light">
                  <h4>Adelaide Office</h4>
                  <p className="mt-3">
                    <img
                      src={sLocation}
                      alt="s-location"
                      className="me-2"
                      style={{ height: "25px" }}
                    />
                    <strong style={{ color: "#001070" }}>Address:</strong> Para
                    Hills SA 5096
                  </p>
                  <p>
                    <Link
                      to="tel:0406958557"
                      className="text-decoration-none"
                      style={{ color: "#444" }}
                    >
                      <img
                        src={sCall}
                        alt="s-call"
                        className="me-2"
                        style={{ height: "25px" }}
                      />
                      <strong style={{ color: "#001070" }}>Phone:</strong> +61
                      406 958 557
                    </Link>
                  </p>

                  <p>
                    <Link
                      to="mailto:info@shinycleaner.com"
                      className="text-decoration-none "
                      style={{ color: "#444" }}
                    >
                      <img
                        src={sMail}
                        alt="s-mail"
                        className="me-2"
                        style={{ height: "20px" }}
                      />
                      <strong style={{ color: "#001070" }}>Email:</strong>{" "}
                      info@shinycleaner.com
                    </Link>
                  </p>
                  <p>
                    <img
                      src={sClock}
                      alt="s-clock"
                      className="me-2"
                      style={{ height: "25px" }}
                    />
                    <strong style={{ color: "#001070" }}>Working Hours:</strong>
                    <br />
                    Monday - Friday: 8:00 AM - 8:00 PM
                    <br />
                    Saturday: 9:00 AM - 6:00 PM
                    <br />
                    Sunday: 9:00 AM - 2:00 PM
                  </p>
                </div>

                {/* Melbourne Office - Hidden
                <div className="info-box mt-4 p-3 bg-light">
                  <h4>Melbourne Office</h4>
                  <p className="mt-3">
                    <img
                      src={sLocation}
                      alt="s-location"
                      className="me-2"
                      style={{ height: "25px" }}
                    />
                    <strong style={{ color: "#001070" }}>Address:</strong> Para
                    Hills SA 5096
                  </p>
                  <p>
                    <Link
                      to="tel:0406958557"
                      className="text-decoration-none"
                      style={{ color: "#444" }}
                    >
                      <img
                        src={sCall}
                        alt="s-call"
                        className="me-2"
                        style={{ height: "25px" }}
                      />
                      <strong style={{ color: "#001070" }}>Phone:</strong> +61
                      406 958 557
                    </Link>
                  </p>

                  <p>
                    <Link
                      to="mailto:info@shinycleaner.com"
                      className="text-decoration-none "
                      style={{ color: "#444" }}
                    >
                      <img
                        src={sMail}
                        alt="s-mail"
                        className="me-2"
                        style={{ height: "20px" }}
                      />
                      <strong style={{ color: "#001070" }}>Email:</strong>{" "}
                      info@shinycleaner.com
                    </Link>
                  </p>
                  <p>
                    <img
                      src={sClock}
                      alt="s-clock"
                      className="me-2"
                      style={{ height: "25px" }}
                    />
                    <strong style={{ color: "#001070" }}>Working Hours:</strong>
                    <br />
                    Monday - Friday: 8:00 AM - 8:00 PM
                    <br />
                    Saturday: 9:00 AM - 6:00 PM
                    <br />
                    Sunday: 9:00 AM - 2:00 PM
                  </p>
                </div>
                */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 map-section">
        <div className="container">
          <div className="map-wrapper animated-map shadow-lg rounded-4 overflow-hidden position-relative">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d104749.5741050878!2d138.678256!3d-34.870693!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa635f2ddcbe88963%3A0x4a7a383a4f425b24!2sShiny%20Cleaning!5e0!3m2!1sen!2sin!4v1750331328097!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Shiny Cleaning Map"
            ></iframe>

            {/* <div className="map-overlay d-none d-md-block">
        <h5 className="text-white fw-bold">Visit Us in Adelaide</h5>
        <p className="text-white small">Para Hills SA 5096, Australia</p>
      </div> */}
          </div>
        </div>
      </section>

      <section className="testimonials-section">
        <div className="container">
          <div className="section-header text-center mb-4">
            <p className="subheading">— Testimonials</p>
            <h2>Client Testimonies: Experience with Our Cleaners</h2>
          </div>

          <div className="row">
            {/* Left Summary */}
            <div className="col-lg-3 col-md-4 mb-4 text-center review-summary">
              <p className="rating-label m-0 fw-bold fs-5">EXCELLENT</p>
              <div className="stars">{renderStars(5)}</div>
              <p>
                Based on{" "}
                <strong>{reviewCount !== null ? reviewCount : "..."}</strong>{" "}
                reviews
              </p>
              <img
                src={Google}
                alt="Google"
                style={{ width: "100px", marginTop: "-10px" }}
              />
            </div>

            {/* Testimonials Scrollable */}
            <div className="col-lg-9 col-md-8 position-relative testimonial-scroll-wrapper">
              <div className="testimonial-scroll d-flex" ref={scrollRef}>
                {testimonials.map((item, index) => (
                  <div
                    key={index}
                    className="testimonial-card p-3 mx-2 bg-white rounded shadow"
                  >
                    <div className="card-header d-flex align-items-center mb-2">
                      {item.avatar ? (
                        <img
                          src={`${PUBLIC_BASE_URL}${item.avatar}`}
                          className="avatar-img me-2 rounded-circle"
                          alt={item.name}
                          style={{ width: 40, height: 40 }}
                        />
                      ) : (
                        <div className="avatar me-2">
                          {item.name?.charAt(0)}
                        </div>
                      )}
                      <div>
                        <h5 className="mb-0">{item.name}</h5>
                        <small>{item.date}</small>
                      </div>
                      <img
                        src={`${PUBLIC_BASE_URL}${item.platform}`}
                        alt="Platform"
                        style={{ width: 16, marginLeft: "auto" }}
                      />
                    </div>

                    <div className="rating mb-2">
                      {renderStars(item.rating)}
                      {item.verified && (
                        <img
                          src={`${PUBLIC_BASE_URL}${item.verified}`}
                          alt="verified"
                          style={{
                            width: 16,
                            marginLeft: "6px",
                            verticalAlign: "middle",
                          }}
                        />
                      )}
                    </div>

                    <p className="comment-truncate m-0">{item.comment}</p>
                  </div>
                ))}
              </div>

              {/* Arrow Controls */}
              <div className="d-flex justify-content-center gap-2 scroll-controls">
                <button
                  onClick={() => scroll("left")}
                  className="scroll-arrow left-arrow"
                >
                  <FaChevronLeft />
                </button>
                <button
                  onClick={() => scroll("right")}
                  className="scroll-arrow right-arrow"
                >
                  <FaChevronRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactUs;
